import { readBaseMetadataByName, readBaseMetadataByNameAndModule } from '@msdk/definitions'
import { useEffect, useState } from 'react'

import { useI18nContext } from '../providers'
import { parseSitemapViews, sameSitemapViews } from '../utils'

export function useSitemapViews(entityName: string, moduleName: string) {
  const _pairs = parseSitemapViews(entityName, moduleName)
  const [pairs, setPairs] = useState(_pairs)
  const i18n = useI18nContext()

  useEffect(() => {
    if (sameSitemapViews(pairs, _pairs)) {
      return
    }
    setPairs(_pairs)
  }, [_pairs, pairs])

  useEffect(() => {
    pairs.forEach((p) => {
      const data = readBaseMetadataByName(p.entityName)
      const moduleMetadata = readBaseMetadataByNameAndModule(p.entityName, p.viewName)
      i18n.load(data!, moduleMetadata!, p.viewName)
    })
  }, [pairs])

  return _pairs
}
